<template>
  <div class="mixin-components-container">
    <el-row v-loading="listLoading">
      <el-card v-for="(item, index) in list" :key="index" class="box-card" style="margin-bottom:30px">
        <div slot="header" class="clearfix">
          <el-col v-if="roles[0] == 'Teacher' || roles[0] == 'Admin'" :span="12" class="text-left">
            <span>Student :
              <span v-if="item.students.length == 1">{{ item.students[0].name }}</span>
              <span v-if="item.students.length > 1">
                {{ item.students.length }}人
                <el-button type="success" size="small" @click="studentLists(item.number, item.courseTitle, item.students)">More</el-button>
              </span>
            </span>
          </el-col>
          <el-col v-if="roles[0] == 'Student' || roles[0] == 'Admin'" :span="12" class="text-left">
            <span>Teacher : {{ item.teacherName }}</span>
          </el-col>
        </div>
        <div style="margin-bottom:50px;">
          <el-col :span="12" :xs="24" class="text-left">
            <el-row>
              <span>Time :</span>
              <el-button type="warning" size="small" @click="timeLists(item.id, item.number, item.courseTitle, item.lessonTimes)">More</el-button>
            </el-row>
            <el-row>
              <el-col :span="20" :xs="24">
                <el-table :data="item.lessonTimes">
                  <el-table-column align="center" label="No" width="50">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Begin">
                    <template slot-scope="scope">
                      {{ scope.row.beginTime }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="End">
                    <template slot-scope="scope">
                      {{ scope.row.endTime }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Status">
                    <template slot-scope="scope">
                      {{ scope.row.timeStatus | statusTrans }}
                    </template>
                  </el-table-column>
                </el-table>
                </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24" class="text-left">
            <el-row class="text-left" style="margin-bottom:30px;">
              <span>No. : {{ item.number }}</span>
            </el-row>
            <el-row class="text-left" style="margin-bottom:30px;">
              <span>Price : {{ item.coursePrice }}</span>
            </el-row>
            <el-row class="text-left" style="margin-bottom:30px;">
              <span>Course : {{ item.courseTitle }}</span>
              <span>( {{ item.courseTypeName }} )</span>
            </el-row>
            <el-row class="text-right" style="margin-bottom:30px;">
              <el-button type="primary" size="mini" @click="comment(item.number, item.courseTitle, item.id)">
                Read Messages
              </el-button>
            </el-row>
          </el-col>
        </div>
      </el-card>
      <el-row>
        <el-col :span="24"><div class="text-center">No Class Found</div></el-col>
      </el-row>
    </el-row>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    <CommentDialog :dialog-comment-visible-prop="dialogCommentVisible" />
    <TimeDialog :dialog-time-visible-prop="dialogTimeVisible" />
    <StudentDialog :dialog-student-visible-prop="dialogStudentVisible" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import EventResource from '@/api/event'
const eventResource = new EventResource()
import CommentDialog from '@/views/events/history/comment'
import StudentDialog from '@/views/events/history/student'
import TimeDialog from '@/views/events/history/time'

import { mapGetters } from 'vuex'

export default {
  name: 'History',
  components: { Pagination, CommentDialog, StudentDialog, TimeDialog },
  filters: {
    statusTrans(status) {
      if (status === 'not_started') {
        return '未上課'
      } else {
        return '已上課'
      }
    }
  },
  data() {
    return {
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      dialogCommentVisible: false,
      commentLists: null,
      currentCommentListLessonId: 0,
      currentCommentListLessonNumber: '',
      currentCommentListCourseTitle: '',
      dialogStudentVisible: false,
      currentStudentListLessonNumber: '',
      currentStudentListCourseTitle: '',
      currentStudentListData: [],
      dialogTimeVisible: false,
      currentTimeListLessonId: 0,
      currentTimeListLessonNumber: '',
      currentTimeListCourseTitle: '',
      currentTimeListData: [],
      list: null,
      total: 0,
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        12: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 12)' },
        13: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 13)' },
        23: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again. (Error Code 23)' }
      }
    }
  },
  computed: {
    // roles: function () {
    //   return this.$root.state.user.roles;
    // }
    ...mapGetters([
      'roles'
    ])
  },
  created() {
    console.log(this.roles)
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await eventResource.getLessonList(this.listQuery)
      console.log(data)
      this.list = data.items
      this.total = data.total
      this.listLoading = false
    },
    async comment(lessonNumber, courseTitle, lessonId) {
      await this.getCommentByLesson(lessonId)
      this.currentCommentListLessonId = lessonId
      this.currentCommentListLessonNumber = lessonNumber
      this.currentCommentListCourseTitle = courseTitle
      this.dialogCommentVisible = true
    },
    async getCommentByLesson(lessonId) {
      const { data } = await eventResource.getCommentByLesson(lessonId)
      this.commentLists = data.items
    },
    studentLists(lessonNumber, courseTitle, students) {
      this.currentStudentListLessonNumber = lessonNumber
      this.currentStudentListCourseTitle = courseTitle
      this.currentStudentListData = students
      this.dialogStudentVisible = true
    },
    timeLists(lessonId, lessonNumber, courseTitle, times) {
      this.currentTimeListLessonId = lessonId
      this.currentTimeListLessonNumber = lessonNumber
      this.currentTimeListCourseTitle = courseTitle
      this.currentTimeListData = times
      this.dialogTimeVisible = true
    },
    async createComment(item) {
      console.log(item)
      const { data } = await eventResource.createComment(item)
      const actionTitle = 'Send Message '
      if (data.code === 0) {
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        await this.getCommentByLesson(item.lessonId)
      } else {
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>

<style scoped>
.mixin-components-container {
  background-color: #f0f2f5;
  padding: 30px;
  min-height: calc(100vh - 84px);
}
.component-item{
  min-height: 100px;
}
</style>
